app.controller('exercisesAddEvaluationAnswerCtrl', ['$scope', '$rootScope', '$mdDialog',
	function ($scope, $rootScope, $mdDialog) {
		$scope.close = function() {
			$mdDialog.cancel();
		}
	}
]);